import { Alert, FormControlLabel, Stack, Switch } from '@mui/material'
import { api } from '../api/client'
import type { EventDetails } from '../api/generated/EventDetails'
import type { EventSettings } from '../api/generated/EventSettings'
import { useAction } from '../api/useAction'
import { useEvent } from './EventContext'

export function settingsOf(event: EventDetails): EventSettings {
  return {
    name: event.name,
    timezone: event.timezone,
    contact_phone: event.contact_phone,
    reminder_lead_minutes: event.reminder_lead_minutes,
    withdrawal_deadline_hours: event.withdrawal_deadline_hours,
    applications_open: event.applications_open,
    starts_on: event.starts_on,
    ends_on: event.ends_on,
  }
}

export function saveSettings(event: EventDetails, settings: EventSettings) {
  return api.patch<EventDetails>(`/events/${event.slug}`, settings)
}

/** Opens and closes applications. */
export function Applications() {
  const { event, setEvent } = useEvent()
  const { error, pending, run } = useAction()
  const toggle = () =>
    run(async () =>
      setEvent(
        await saveSettings(event, {
          ...settingsOf(event),
          applications_open: !event.applications_open,
        }),
      ),
    )
  return (
    <Stack spacing={1}>
      <FormControlLabel
        control={<Switch checked={event.applications_open} disabled={pending} onChange={toggle} />}
        label="Inscriptions ouvertes"
      />
      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  )
}
